import {BiReportSearchComponent} from './bi-report-search.component';

export const BiReportRoutes = [
  {
    path: 'bi-report-search',
    component: BiReportSearchComponent,
  },
];
